import { NgModule } from '@angular/core';
import { StrategyTriggersComponent } from './strategy-triggers.component';
import { CommonModule } from '@angular/common';
import { DevExtremeModule } from '../devextreme.module';

@NgModule({
  imports: [
    CommonModule,
    DevExtremeModule
  ],
  exports: [StrategyTriggersComponent],
  declarations: [StrategyTriggersComponent],
  providers: [],
})
export class StrategyTriggersModule { }
